// purely.: popup etter «Legg i handlekurv» (snippets/purely-lagt-til.liquid).
// Skuffen tegnes på nytt som før, men åpnes ikke når en vare legges i fra en side og kampanjen mangler varer.
// Da vises popupen i stedet. Er skuffen alt åpen (oppsalget i skuffen), eller er kampanjen fullført, går alt som før.
(() => {
  const GRUPPE = 3;
  const rot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const tekst = (rest) =>
    rest === 1
      ? 'Legg til ett produkt til, så får du et tredje gratis. Alle tre må ligge i handlekurven, og den billigste blir gratis.'
      : 'Legg til ett produkt til, så blir den billigste gratis.';

  class PurelyLagtTil extends HTMLElement {
    connectedCallback() {
      this.ark = this.querySelector('.purely-lt__ark');
      this.liste = this.querySelector('[data-liste]');
      try {
        this.forslag = JSON.parse(this.querySelector('[data-forslag]').textContent);
      } catch (e) {
        this.forslag = [];
      }
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-lukk]')) return this.skjul();
        if (e.target.closest('[data-til-kurven]')) return this.skjul(true);
        const knapp = e.target.closest('[data-legg-til]');
        if (knapp) this.leggTil(knapp);
      });
      this.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') this.skjul();
      });
    }

    // Kalles etter at skuffen er tegnet på nytt uten å åpnes
    async etterLagtTil(skuff, tilstand) {
      this.skuff = skuff;
      let kurv;
      try {
        kurv = await (await fetch(rot + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      } catch (e) {
        return this.skjul(true);
      }
      // Alle varer teller i kampanjen, også abonnement. Gratisvaren er alltid en engangsvare,
      // fordi Shopify ikke gir kjøp X få Y på selve abonnementsvaren (eierens valg A, 2026-10-23).
      const antall = kurv.item_count;
      const rest = antall % GRUPPE;
      if (rest === 0) return this.skjul(true);

      const engangs = kurv.items.filter((i) => !i.selling_plan_allocation);
      const laveste = engangs.length ? Math.min(...engangs.map((i) => i.original_price)) : Infinity;
      const iKurven = new Set(kurv.items.map((i) => i.product_id));
      if (tilstand && tilstand.product_title && !this.hasAttribute('open')) {
        this.querySelector('[data-lagt]').textContent = `${tilstand.product_title} er lagt i handlekurven`;
      }
      this.querySelector('[data-tekst]').textContent = tekst(rest);
      const trinn = this.querySelector('[data-trinn]');
      trinn.setAttribute('aria-valuenow', rest);
      trinn.querySelectorAll('.purely-kurv__ledd').forEach((ledd, i) => ledd.classList.toggle('purely-kurv__ledd--fylt', i < rest));
      this.tegnForslag(this.forslag.filter((f) => f.tilgjengelig && !iKurven.has(f.produkt)).slice(0, 3), rest, laveste);
      this.vis();
    }

    tegnForslag(forslag, rest, laveste) {
      this.liste.replaceChildren();
      this.liste.hidden = forslag.length === 0;
      for (const f of forslag) {
        const li = document.createElement('li');
        li.className = 'purely-lt__vare';
        if (f.bilde) {
          const img = document.createElement('img');
          img.className = 'purely-lt__bilde';
          img.src = f.bilde;
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          li.append(img);
        }
        const info = document.createElement('div');
        info.className = 'purely-lt__info';
        const navn = document.createElement('a');
        navn.className = 'purely-lt__navn';
        navn.href = f.url;
        navn.textContent = f.tittel;
        const pris = document.createElement('span');
        pris.className = 'purely-lt__pris';
        pris.textContent = f.prisTekst;
        if (rest === GRUPPE - 1 && f.pris <= laveste) {
          const gratis = document.createElement('span');
          gratis.className = 'purely-lt__gratis';
          gratis.textContent = 'Blir gratis';
          pris.append(' ', gratis);
        }
        info.append(navn, pris);
        const knapp = document.createElement('button');
        knapp.type = 'button';
        knapp.className = 'purely-lt__legg-til';
        knapp.dataset.leggTil = f.variant;
        knapp.textContent = 'Legg til';
        knapp.setAttribute('aria-label', `Legg ${f.tittel} i handlekurven`);
        li.append(info, knapp);
        this.liste.append(li);
      }
    }

    async leggTil(knapp) {
      if (knapp.disabled || !this.skuff) return;
      knapp.disabled = true;
      knapp.setAttribute('aria-busy', 'true');
      try {
        const svar = await fetch(rot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(knapp.dataset.leggTil), quantity: 1 }],
            sections: this.skuff.getSectionsToRender().map((s) => s.id),
            sections_url: window.location.pathname,
          }),
        });
        const data = await svar.json();
        if (!svar.ok || data.status) throw new Error(data.description || 'Kunne ikke legge til');
        // Skuffen er lukket, så den tegnes på nytt uten å åpnes, og popupen oppdateres eller viker for skuffen
        this.skuff.renderContents(data);
      } catch (e) {
        knapp.disabled = false;
        knapp.removeAttribute('aria-busy');
        knapp.textContent = 'Prøv igjen';
      }
    }

    vis() {
      if (this.hasAttribute('open')) return;
      this.forrigeFokus = document.activeElement;
      this.hidden = false;
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      requestAnimationFrame(() => this.ark.focus());
    }

    skjul(aapneSkuff = false) {
      const varApen = this.hasAttribute('open');
      this.removeAttribute('open');
      this.hidden = true;
      if (aapneSkuff && this.skuff) {
        this.skuff.open();
      } else {
        document.body.classList.remove('overflow-hidden');
        if (varApen && this.forrigeFokus) this.forrigeFokus.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get('purely-lagt-til')) customElements.define('purely-lagt-til', PurelyLagtTil);

  customElements.whenDefined('cart-drawer').then(() => {
    const Skuff = customElements.get('cart-drawer');
    if (Skuff.prototype.purelyLagtTil) return;
    const opprinnelig = Skuff.prototype.renderContents;
    Skuff.prototype.renderContents = function (tilstand) {
      const popup = document.querySelector('purely-lagt-til');
      if (!popup || this.classList.contains('active')) return opprinnelig.call(this, tilstand);
      // Tegn skuffen på nytt uten å åpne den. Dawn åpner i en setTimeout, så åpningen skygges til den har gått
      this.open = () => {};
      opprinnelig.call(this, tilstand);
      setTimeout(() => {
        delete this.open;
        popup.etterLagtTil(this, tilstand);
      });
    };
    Skuff.prototype.purelyLagtTil = true;
  });
})();
